import { Grid, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import i18n, { translations, _t, I18nTranslator } from "utils/i18n";
import { ColorHelper, StatusHelper, TableHelper, TimeHelper } from "helpers";
import { DeliveryOrderActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";
import { EDeliveryStatus, IDeliveryOrder, IPaginateApiResponse } from "model";
import { DeliveryStatusCell, StatusCell } from "components/atoms";
import { DELIVERY_TICKET_STATUS } from "common";

const DeliveryOrderDocument = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const pathname = location.pathname;
  const data = useAppSelector(
    (state) => state.DeliveryOrderReducer.deliveryOrder
  ) as IPaginateApiResponse<IDeliveryOrder[]>;
  const action = useAppSelector((state) => state.DeliveryOrderReducer.action);

  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    _getAllDeliveryOrders();
  }, [searchText]);

  const _getAllDeliveryOrders = (pageNumber = 1) => {
    dispatch(
      DeliveryOrderActions.getAllDeliveryOrders.request({
        pageNumber: pageNumber,
        pageSize: 100,
        searchText: searchText,
      })
    );
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "deliveryTicketCode",
      headerName: I18nTranslator(translations.receive.documentId),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "companyCode",
      headerName: I18nTranslator(translations.receive.companyId),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "companyName",
      headerName: I18nTranslator(translations.receive.companyName),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "province",
      headerName: I18nTranslator(translations.receive.address),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "deliveryAddress",
      headerName: I18nTranslator(translations.receive.shipToAddress),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "deliveryDate",
      headerName: I18nTranslator(translations.receive.deliveryDate),
      size: "small",
      align: "left",
      renderCell: ({ value }) => (
        <Typography>{TimeHelper.formatDate(value)}</Typography>
      ),
    }),
    TableHelper.createCell({
      field: "status",
      headerName: I18nTranslator(translations.status),
      align: "left",
      size: "medium",
      renderCell: ({ value }) => (
        <StatusCell
          bgcolor={ColorHelper.getDeliveryStatusColor(value as EDeliveryStatus)}
        >
          {StatusHelper.getDeliveryStatusString(value)}
        </StatusCell>
      ),
    }),
    TableHelper.createCell({
      field: "listOrderNumbers",
      headerName: I18nTranslator(translations.receive.invoiceNumber),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "listFreeItems",
      headerName: I18nTranslator(translations.receive.discountProduct),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "deliveryUOMSum",
      headerName: I18nTranslator(translations.receive.deliverUnit),
      size: "large",
      align: "left",
    }),
    TableHelper.createCell({
      field: "receiptBy",
      headerName: I18nTranslator(translations.receive.receiver),
      size: "small",
      align: "left",
    }),

    TableHelper.createCell({
      field: "grossWeight",
      headerName: I18nTranslator(translations.receive.totalWeight),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "freeItemsWeight",
      headerName: I18nTranslator(translations.receive.discountProductWeight),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "truckNo",
      headerName: I18nTranslator(translations.receive.vehicleNumber),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "driver",
      headerName: I18nTranslator(translations.receive.driver),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "truckSupplier",
      headerName: I18nTranslator(translations.receive.transportUnit),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "deliveverSign",
      headerName: I18nTranslator(translations.receive.deliver),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "description",
      headerName: I18nTranslator(translations.receive.description),
      size: "medium",
      align: "left",
    }),
  ];

  return (
    <div>
      <Grid container>
        <AppTable<any>
          title={i18n.t(_t(translations.routes.deliveryOrderDocument))}
          loading={action.includes(
            DeliveryOrderActions.getAllDeliveryOrders.requestName
          )}
          data={data}
          columns={COLUMNS}
          hideDownload
          hideAddNew
          hideImport
          searchPlaceholder={I18nTranslator(
            translations.placeholder.searchReceiveDocument
          )}
          onCellClick={(params) =>
            history.push({
              pathname: `${pathname}/${params.row.id}&${params.row.deliveryTicketCode}`,
              state: {
                item: JSON.stringify(params.row),
              },
            })
          }
          onSearch={setSearchText}
          onChangePage={_getAllDeliveryOrders}
          removeActionColumn
        />
      </Grid>
    </div>
  );
};

export default DeliveryOrderDocument;
